
import {Component, Vue, Watch} from "vue-property-decorator";
import {MuvekkilEntity} from "@/entity/MuvekkilEntity";
import KisiInfo from "@/components/infos/KisiInfo.vue";
import IletisimList from "@/components/lists/IletisimList.vue";
import AdresSelectableList from "@/components/lists/AdresSelectableList.vue";
import BankaHesabiList from "@/components/lists/BankaHesabiList.vue";
import DokumanList from "@/components/lists/DokumanList.vue";
import TakipList from "@/components/lists/TakipList.vue";
import KurumInfo from "@/components/infos/KurumInfo.vue";
import {KisiEntity} from "@/entity/KisiEntity";
import {KurumEntity} from "@/entity/KurumEntity";
import {AdresEntity} from "@/entity/AdresEntity";
import {TakipEntity} from "@/entity/TakipEntity";
import {AxiosResponse} from "axios";
import {HarcDonemiEntity} from "@/entity/HarcDonemiEntity";

@Component({
  components: {
    KurumInfo,
    TakipList,
    DokumanList,
    BankaHesabiList,
    AdresSelectableList,
    IletisimList,
    KisiInfo,
  }
})
export default class MuvekkilDetayView extends Vue {
  muvekkilItem: any|null=null;
  kisiKurumItem: any | null = null;
  muvekkilTakipleri: Array<TakipEntity> =[];
  harcSecim:boolean=false
  harcItems:Array<any> = [];
  secilenler:Array<any> = [];
  iletisim_bilgileri :any = []
  adresler:any  = {}
  banka_hesaplari :any = []
  file:any = []

  @Watch('muvekkilItem.kurum.harc_muaf_mi')
  changeHarcMuaf(){
    if (this.muvekkilItem?.kurum.harc_muaf_mi){
      this.harcSecim = true
    }else{
      this.secilenler=[]
      this.harcSecim = false
    }
  }

  harcUpdate(){
    let harcUpdateData:any={
      kurum_id:this.muvekkilItem?.kurum.kurum_id,
      muaf_harclar:this.secilenler,
      harc_muaf_mi:this.muvekkilItem?.kurum.harc_muaf_mi
    }

    this.$http.put('/api/v1/kurum-muaf-harclar',harcUpdateData).then(()=>{
      this.laodKurumMuafHarclar()
    })
  }


  laodHarcList(){
    this.$http.get("/api/v1/harc-donemi").then((response: AxiosResponse<Array<HarcDonemiEntity>>) => {
      const lastItem = response.data.length - 1;
      this.harcItems = response.data[lastItem].harclar;
    });
  }

  get action() {
    if (this.muvekkilItem?.kisi)
      return "/api/v1/kisi/" + this.muvekkilItem?.kisi.id;
    else
      return "/api/v1/kurum/" + this.muvekkilItem?.kurum.kurum_id;
  }

  mounted() {
    let activeProcess = {id: this.$route.params.id, key: 'muvekkil-detay'}
    this.$store.commit('setActiveProcess', activeProcess);
    this.load();
    this.loadIletisimBilgileri();
    this.loadAdresBilgileri();
    this.loadBankaBilgileri();
    this.loadDokumanBilgileri();
    this.laodKurumMuafHarclar();
  }

  loadIletisimBilgileri(){
    this.$http.get('/api/v1/muvekkil/' + this.$route.params.id + '/iletisim').then((response:any)=>{
      this.iletisim_bilgileri = response.data;
    })
  }

  loadAdresBilgileri(){
    this.$http.get('/api/v1/muvekkil/' + this.$route.params.id + '/adresler').then((response:any)=>{
      this.adresler = response.data;
    })
  }

  loadBankaBilgileri(){
    this.$http.get('/api/v1/muvekkil/' + this.$route.params.id + '/bankalar').then((response:any)=>{
      this.banka_hesaplari = response.data;
    })
  }

  loadDokumanBilgileri(){
    this.$http.get('/api/v1/muvekkil/' + this.$route.params.id + '/files').then((response:any)=>{
      this.file = response.data.files;
    })
  }

  laodKurumMuafHarclar(){
    this.$http.get('/api/v1/muvekkil/' + this.$route.params.id + '/kurum-muaf-harc').then((response:any)=>{
      this.secilenler = response.data;
    })
  }

  load() {
    this.$http.get('/api/v1/muvekkil/' + this.$route.params.id).then(muvekkilResponse => {
      this.muvekkilItem = muvekkilResponse.data;
      /*let action = '/api/v1/' + (muvekkilResponse.data.kisi_id ? 'kisi' : 'kurum') + '/' + (muvekkilResponse.data.kisi_id ? muvekkilResponse.data.kisi_id : muvekkilResponse.data.kurum_id);
      this.$http.get(action).then(kisiResponse => {
        if (muvekkilResponse.data.kisi_id) {
          this.kisiKurumItem = kisiResponse.data.kisi;
        } else {
          this.kisiKurumItem = kisiResponse.data;
        }
        this.secilenler= this.kisiKurumItem.kurum_muaf_harclar
      });*/

      /*let takipIdleri: Array<number> = [];
      muvekkilResponse.data.takipler.forEach((takip:any)=> takipIdleri.push(takip.id));
      if (takipIdleri.length > 0)
        this.$http.post('/api/v1/muvekkil/takip-listesi', takipIdleri).then((res) => {
          this.muvekkilTakipleri = res.data;
        });*/
      this.laodHarcList()
    })

  }

  onDefaultAdresChange(adres: AdresEntity) {
    if (adres.adres_tur_id) {
      this.$http.patch(this.action + '/varsayilan-adres', adres).then(() => this.loadAdresBilgileri());
    }
  }
}
